import React from 'react';
import styles from './DeviceItem.scss';
import classNames from 'classnames/bind';
import {Link} from 'react-router-dom';

const cx = classNames.bind(styles);

const DeviceItem = ({
  deviceId,
  deviceName,
  isEcobee
}) => {
  return (
    <Link to={`/thermostats/${isEcobee ? 'ecobeehome' : 'sensi'}/${deviceId}`} className={cx('DeviceItem')}>
      {`${deviceName} (${deviceId})`}
    </Link>
  );
};

export default DeviceItem;


// WEBPACK FOOTER //
// ./src/app/thermostats/components/DeviceItem/DeviceItem.js